module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_cancer_down-e22a2244e6743b6598f224cb13be5e8f.png";